<template>
  <header id="header">
    <div class="w1320 flex flex-align-center flex-space-between">
      <div class="menu" @click="menuSwitch" :class="{open:menuShow}">
        <div class="item"></div>
        <div class="item"></div>
        <div class="item"></div>
      </div>
      <div class="logo">
        <img class="white" src="@/assets/images/logo.png" alt="">
        <img class="black" src="@/assets/images/logo_black.png" alt="">
      </div>
      <nav>
        <div class="item">
          <router-link to="/">首页</router-link>
        </div>
        <div class="item">
          <router-link to="/productsType">产品中心</router-link>
        </div>
        <div class="item">
          <router-link to="/about">博洋生活</router-link>
        </div>
        <div class="item">
          <router-link to="/news">企业动态</router-link>
        </div>
        <div class="item">
          <router-link to="/agent">授权代理</router-link>
        </div>
        <div class="item">
          <router-link to="/contact">联系我们</router-link>
        </div>
      </nav>
      <!-- <el-dropdown class="dropdown" trigger="click" @command="handleCommand">
        <div class="menu el-icon-menu"></div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="/">首页</el-dropdown-item>
          <el-dropdown-item command="/productsType">产品中心</el-dropdown-item>
          <el-dropdown-item command="/about">博洋生活</el-dropdown-item>
          <el-dropdown-item command="/news">企业动态</el-dropdown-item>
          <el-dropdown-item command="/agent">授权代理</el-dropdown-item>
          <el-dropdown-item command="/contact">联系我们</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown> -->
      <div class="right flex">
        <div class="search" @click="inputShow=!inputShow">
          <i class="el-icon-search"></i>
        </div>
        <div class="cart">
          <a class="el-icon-shopping-cart-2" href="https://mall.jd.com/index-987766.html" target="_blank"></a>
        </div>
      </div>
    </div>
    <el-collapse-transition>
      <div class="w1320 flex flex-content-center" v-show="inputShow">
        <div class="form">
          <el-input class="input" v-model="input" placeholder="Search Products"></el-input>
        </div>
      </div>
    </el-collapse-transition>
  </header>
</template>

<script>
import Scrollbar from 'smooth-scrollbar';
export default {
  data(){
    return{
      scrollbar: '',
      scrollTop: 0,
      input:'',
      inputShow:false,
      menuShow:false
    }
  },
  watch: {
    $route: 'getScrollbar'
  },
  mounted() {
    this.getScrollbar()
  },
  methods: {
    getScrollbar(){
      this.menuShow=false
      this.$nextTick(()=>{
        this.scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
        if(this.scrollbar){
          this.scrollbar.addListener((status) => {
            if(status.offset.y>100){
              if(!document.getElementById('header').classList.contains("on-scroll")){
                document.getElementById('header').classList.add("on-scroll")
              }
            }else{
              if(document.getElementById('header').classList.contains("on-scroll")){
                document.getElementById('header').classList.remove("on-scroll")
              }
            }
            this.scrollTop=status.offset.y
          });
        }
      })
    },
    handleCommand(command) {
      this.$router.push(command)
    },
    menuSwitch(){
      this.menuShow=!this.menuShow
      this.$emit('menushow',this.menuShow)
    }
  }
}
</script>

<style scoped>
header{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  border-bottom: 1px solid rgba(255,255,255,.2);
  z-index: 102;
	animation-name: noscroll;
	animation-duration: .5s;
	animation-timing-function: linear;
  color: #fff;
}
header.on-scroll{
  background-color: #fff;
  border-color: #f0f0f0;
	animation-name: scroll;
	animation-duration: .5s;
	animation-timing-function: linear;
  color: #000;
}
@keyframes noscroll {
  0% {
    transform: translateY(0);
    background-color: #fff;
    color: #000;
  }
  50% {
    transform: translateY(-100%);
    background-color: #fff;
    color: #000;
  }
  51% {
    transform: translateY(-100%);
    background-color: transparent;
    color: #fff;
  }
  100% {
    transform: translateY(0);
  }
}
@keyframes scroll {
  0% {
    transform: translateY(-100%);
  }
  100% {
    transform: translateY(0);
  }
}
header .logo img.black{
  display: none;
}
header.on-scroll .logo img.black{
  display: block;
}
header.on-scroll .logo img.white{
  display: none;
}
header nav{
  flex: auto;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
header nav .item{
  font-size: 14px;
  line-height: 84px;
  position: relative;
  transition: .5s;
}
header nav .item:hover,
header nav .item.active{
  color: #365666;
}
header nav .item:hover::after,
header nav .item.active::after{
  content: "";
  position: absolute;
  bottom: -1px;
  width: 100%;
  height: 1px;
  background-color: #5e7987;
}
header nav .item a{
  display: block;
}
header .menu{
  display: none;
  position: relative;
  width: 21px;
  height: 21px;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
}
header .menu .item{
  height: 1px;
  background-color: #fff;
  width: 100%;
  transition: .4s;
  transform-origin: 0 50%;
}
header .menu .item:nth-of-type(2){
  width: 19px;
}
header .menu .item:nth-of-type(3){
  width: 15px;
}
header .menu.open .item:nth-of-type(1){
  width: 141.42%;
  transform: rotate(45deg);
}
header .menu.open .item:nth-of-type(2){
  display: none;
}
header .menu.open .item:nth-of-type(3){
  width: 141.42%;
  transform: rotate(-45deg);
}
header .right{
  font-size: 14px;
}
header .right .search{
  padding-left: 20px;
  padding-right: 20px;
  border-right: 1px solid;
  cursor: pointer;
}
header .right .cart{
  padding-left: 20px;
}
header .right .cart a{
  transition: .5s;
}
header .right .cart a:hover{
  color: #365666;
}
header .form .input>>>input{
  background-color: transparent;
  border: none;
  border-bottom: 1px solid #dedede;
  text-align: center;
  width: 670px;
}
@media(max-width: 768px){
  header{
    padding: 10px;
    /* display: flex;
    align-items: center;
    justify-content: space-between; */
  }
  header nav,
  header .right{
    display: none;
  }
  header .menu{
    display: flex;
  }
  header.on-scroll .menu .item{
    background-color: #000;
  }
}
</style>
